export const projectInfo = {
    name: 'Andlossia',
    version: '2.1.9',
  description: 'Smart CMS platform powered by SchemaFirst',
    keywords: [],
    author: 'andlossia',
    icon: '../assets/icon.ico',
    logo: '../assets/logo.png',
    license: 'MIT',
    repository: {
      type: 'git',
      url: 'https://github.com/andlossia/CMS.git'
    }
  };